import { useTranslation } from "react-i18next";
import queryRecharge from "../../services/recharge/queryRecharge";
import noList from "../../assets/images/no_list.webp";
import { dateToLocaleString } from "../../utils/common";
import Item from "../Pricing/Item";

const SpecialOffers = () => {
  const { t } = useTranslation();
  const { data: dataOnlyMovil, isLoading } =
    queryRecharge().listRechargeByType('movil');

  const specials = dataOnlyMovil?.lists_recharge
    .filter((item) => item.rechargeable_type === 'OfferProduct')
    .concat(
      dataOnlyMovil?.lists_recharge_schedule.filter(
        (item) => item.rechargeable_type === 'OfferProduct',
      ),
    );

  const subtitle =
    specials?.length > 0
      ? t('offers.subtitle2', {
          dateRange: dateToLocaleString(specials[0].date_init, specials[0].date_end),
        })
      : isLoading
        ? t('offers.loadingText2')
        : t('offers.noOffers');

  return (
    <div className="p-5 py-10 lg:py-16 bg-gradient-to-br from-[#187672] via-[#399772] to-[#D9E022]">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 select-none">
        <div className="mx-auto max-w-4xl text-center space-y-6">
          <div className={`max-w-4xl text-center mx-auto flex flex-col gap-1`}>
            <span className={'text-white mt-2 text-3xl font-brave-hunter tracking-tight sm:text-5xl'}>
              {t('offers.title2')}
            </span>
            <span className="lg:text-xl text-white md:font-light tracking-tight text-lg px-5 md:px-0">
              {subtitle}
            </span>
          </div>
        </div>

        <div className="isolate mx-auto mt-10 lg:px-24 grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {isLoading && Array.from({ length: 3 }).map((_, index) => (
            <Item key={`tier-loading-${index}`} tier={{}} isLoading={isLoading}/>
          ))}
          {!isLoading && !specials?.length && (
            <div className="col-span-full flex justify-center">
              <img src={noList} alt="No results" className="max-w-xs w-full" />
            </div>
          )}
          {!isLoading && specials?.map((tier, index) => (
            <Item key={`tier-${index}`} tier={tier} special/>
          ))}
        </div>
      </div>
    </div>
  )

}

export default SpecialOffers;
